import {match} from 'ts-pattern';

import {FinancingTemplateDraft} from '../types/FinancingTemplateDraft';

type PaymentStep = FinancingTemplateDraft['downPaymentStep'] | null;

/** The percentage increment a down-payment or balloon-payment bracket advances by. */
export function getPaymentStep(step: PaymentStep) {
  return match(step)
    .with('ONE_PERCENT', () => 1)
    .with('FIVE_PERCENT', () => 5)
    .with('TEN_PERCENT', () => 10)
    .with(null, () => 10)
    .exhaustive();
}
